<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      border
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="vtableData"
      :columns="tableColumns"
      :edit-config="{ enabled: !disabled, trigger: 'click', mode: 'row' }"
      :height="tableHeight - 111"
      size="mini"
      :edit-rules="validRules"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div class="side-frame-success">
            <span class="side-frame-text">拼点费信息</span>
            <el-divider direction="vertical"></el-divider>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-success"
              @click="add()"
              v-if="!disabled"
              ><i class="el-icon-plus" />添加
            </b-button>
            <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              v-if="!disabled"
              @click="$refs.table.removeCheckboxRow()"
              ><i class="el-icon-delete" />删除
            </b-button>
          </div>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          v-if="!disabled"
        >
          <i
            class="el-icon-delete tool-btn"
            v-if="!disabled"
            @click="delRow(row)"
          ></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    disabled: { type: Boolean },
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      vtableData: [],
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 40,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'checkbox',
        },
        {
          field: 'col-opt',
          title: '操作',
          headerAlign: 'center',
          align: 'left',
          width: 50,
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'seqNo',
          title: '序号',
          headerAlign: 'center',
          align: 'center',
          width: 50,
        },
        {
          field: 'vehicleModel',
          headerAlign: 'center',
          align: 'center',
          minWidth: 100,
          title: '车型',
          editRender: {
            name: 'dict-select',
            props: {
              size: 'mini',
              default: true,
              clearable: true,
              filterable: true,
              body: { type: 'vehicleModel' },
            },
          },
        },
        {
          field: 'regionLimit',
          align: 'center',
          minWidth: 80,
          title: '同/跨区',
          editRender: {
            name: 'ElSelect',
            options: [],
            props: {
              size: 'mini',
              default: true,
              clearable: true,
              filterable: true,
            },
          },
        },
        {
          field: 'region',
          headerAlign: 'center',
          align: 'center',
          minWidth: 170,
          title: '行政区',
          editRender: {
            name: 'region-cascader',
            props: {
              size: 'mini',
              clearable: true,
            },
          },
        },
        {
          field: 'price',
          align: 'center',
          minWidth: 100,
          title: '拼点费/点',
          editRender: {
            name: 'ElInputNumber',
            props: {
              precision: 4,
              min: 0,
              step: 0.01,
              placeholder: '请输入单价',
            },
          },
        },
      ],
      regionLimitList: [
        { label: '不限', value: 'A' },
        { label: '同区', value: 'B' },
        { label: '跨区', value: 'C' },
      ],
      validRules: {
        vehicleModel: [{ required: true, message: '请选择车型' }],
        regionLimit: [{ required: true, message: '请选择同/跨区' }],
        price: [{ required: true, message: '请输入拼点费/点' }],
      },
    }
  },
  watch: {
    // 避免父组件重新渲染子组件机制警告
    tableData: {
      handler(tableData) {
        if (tableData && tableData !== [] && tableData.length > 0) {
          this.vtableData = tableData
        }
      },
      immediate: true,
    },
  },
  created() {
    this.tableColumns[5].editRender.options = this.regionLimitList
    this.getData()
  },
  methods: {
    getData() {
      if (!this.contractFeeCode) return
      this.$api
        .contractCustomerFeeTieredListApi({
          contractFeeCode: this.contractFeeCode,
        })
        .then((res) => {
          this.vtableData = res.body.data
        })
    },
    delRow(row) {
      this.$refs.table.remove(row)
      this.resetSeq()
    },
    async add(row) {
      const $table = this.$refs.table
      const { row: newRow } = await $table.insertAt({}, row)
      await $table.setActiveCell(newRow, 'minMatch')
      await this.resetSeq()
    },
    async resetSeq(){
      const tableData = await this.getTableData()
      tableData.forEach((item,index) => {
        this.$set(item,'seqNo',index + 1)
      })
    },
    async getTableData() {
      const $table = this.$refs.table
      return await $table.getTableData().tableData
    },
    async validEvent() {
      const $table = this.$refs.table
      const errMap = await $table.validate(true).catch((errMap) => errMap)
      if (errMap) {
        return false
      } else {
        return true
      }
    },
  },
}
</script>
